module.exports = __webpack_public_path__ + "static/media/stripe-create-account_6.7eb832a9.png";